<template lang="pug">
div
  Input(
    v-model="textInput"
    type="textarea"
    placeholder="199.168.1.0/24\n18.0.0.0/8"
    :rows="6"
  )
</template>

<script>
export default {
    name: "IpDomainList",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            textInput: "",
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.textInput = Array.isArray(newVal) ? newVal.join("\n") : "";
            },
        },
        textInput(val) {
            const parsed = val
                .split("\n")
                .map((item) => item.trim())
                .filter((item) => item);
            this.$emit("input", parsed);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/IpDomainList.vue